import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/rexue-maoxian" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">漫画分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href={`https://${siteInfo.latestAddress}`} target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">访问官网</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门分类</h3>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">使用教程</h3>
            <ul className="space-y-2.5">
              {articles.slice(0, 4).map((article) => (
                <li key={article.id}>
                  <Link
                    to={`/article/${article.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors line-clamp-1 cursor-pointer"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 官方指南. 本站为第三方使用指南网站，非官方网站.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">使用条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}